<div class="controls-section">
  <div class="section-header">
    <h3 class="section-title">Controls</h3>
  </div>

  <!-- Finger mode tabs -->
  <div class="finger-tabs">
    <button class="finger-tab" [class.active]="fingerMode === '1'" (click)="switchFingerMode('1')" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="finger-tab-icon">☝️</span>
      <span class="finger-tab-label">1 Finger</span>
    </button>
    <button class="finger-tab" [class.active]="fingerMode === '2'" (click)="switchFingerMode('2')" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="finger-tab-icon">✌️</span>
      <span class="finger-tab-label">2 Fingers</span>
    </button>
    <button class="finger-tab" [class.active]="fingerMode === '3'" (click)="switchFingerMode('3')" [featureActionState]="'MOBILE_AUTOMATION'">
      <span class="finger-tab-icon">🤟</span>
      <span class="finger-tab-label">3 Fingers</span>
    </button>
  </div>

  <!-- 1-finger actions -->
  <div class="gesture-actions-col" *ngIf="fingerMode === '1'">
    <div class="gesture-label">Gesture Mode</div>
    <div class="gesture-actions">
      <button class="gesture-btn" [class.active]="selectedMode === typeMode" (click)="selectMode(typeMode)" [featureActionState]="'MOBILE_AUTOMATION'">
        <span class="gesture-btn-icon">⌨️</span>
        <span class="gesture-btn-label">type</span>
      </button>
    </div>
  </div>

  <!-- 2-finger actions -->
  <div class="gesture-actions-col" *ngIf="fingerMode === '2'">
    <div class="gesture-label">Gesture Mode</div>
    <div class="gesture-actions">
      <button *ngFor="let mode of twoFingerModes"
        class="gesture-btn"
        [class.active]="selectedMode === mode"
        (click)="selectMode(mode)"
        [featureActionState]="'MOBILE_AUTOMATION'">
        <span class="gesture-btn-icon">{{ getModeIcon(mode) }}</span>
        <span class="gesture-btn-label">{{ getModeLabel(mode) }}</span>
      </button>
    </div>
    <div class="hint-box">
      <div class="hint-title">How to use</div>
      <div class="hint-rows">
        <div class="hint-row"><span class="hint-chip">🔍+</span><span class="hint-desc">tap to zoom in at point</span></div>
        <div class="hint-row"><span class="hint-chip">🔍−</span><span class="hint-desc">tap to zoom out at point</span></div>
        <div class="hint-row"><span class="hint-chip">✌️</span><span class="hint-desc">drag to swipe with 2 fingers</span></div>
      </div>
      <p class="hint-record-note" *ngIf="isRecording && !isPaused">
        2-finger gestures are recorded automatically
      </p>
    </div>
  </div>

  <!-- 3-finger actions -->
  <div class="gesture-actions-col" *ngIf="fingerMode === '3'">
    <div class="gesture-label">Gesture Mode</div>
    <div class="gesture-actions">
      <button *ngFor="let mode of threeFingerModes"
        class="gesture-btn"
        [class.active]="selectedMode === mode"
        (click)="selectMode(mode)"
        [featureActionState]="'MOBILE_AUTOMATION'">
        <span class="gesture-btn-icon">{{ getModeIcon(mode) }}</span>
        <span class="gesture-btn-label">{{ getModeLabel(mode) }}</span>
      </button>
    </div>
  </div>

  <!-- ── Record controls ─────────────────────────────────────────────────── -->
  <div class="panel-divider"></div>
  <div class="record-section">
    <div class="gesture-label">Recording</div>

    <!-- ① Not recording at all -->
    <ng-container *ngIf="!isRecording && !isPaused">
      <button class="btn-record" (click)="promptStartRecording()" [featureActionState]="'MOBILE_AUTOMATION'">
        ⏺ Start Recording
      </button>
    </ng-container>

    <!-- ② Actively recording (not paused) -->
    <ng-container *ngIf="isRecording && !isPaused">
      <div class="rec-active-row">
        <span class="rec-indicator">
          <span class="rec-dot"></span> REC — {{ currentStepName }}
        </span>
      </div>
      <div class="rec-btn-row">
        <button class="btn-new-step"  (click)="promptNewStep()" [featureActionState]="'MOBILE_AUTOMATION'">➕ New Step</button>
        <button class="btn-pause"     (click)="pauseRecording()" [featureActionState]="'MOBILE_AUTOMATION'">⏸ Pause</button>
        <button class="btn-stop"      (click)="stopRecording()" [featureActionState]="'MOBILE_AUTOMATION'">⏹ Stop</button>
      </div>
    </ng-container>

    <!-- ③ Paused -->
    <ng-container *ngIf="isPaused">
      <div class="rec-active-row paused">
        <span class="rec-indicator paused-indicator">
          <span class="rec-dot paused-dot"></span> PAUSED — {{ currentStepName }}
        </span>
      </div>

      <button class="btn-resume" (click)="resumeRecording()" [featureActionState]="'MOBILE_AUTOMATION'">
        ▶ Resume "{{ currentStepName }}"
      </button>

      <ng-container *ngIf="existingSteps.length > 0">
        <div class="gesture-label step-select-label">Or continue in a step:</div>
        <div class="existing-steps-list">
          <button
            *ngFor="let s of existingSteps"
            class="existing-step-btn"
            [class.active-step]="s.name === currentStepName"
            (click)="continueInStep(s.name)"
            [featureActionState]="'MOBILE_AUTOMATION'">
            <span class="step-btn-name">{{ s.name }}</span>
            <span class="step-btn-count">{{ s.actions.length }}</span>
          </button>
        </div>
      </ng-container>

      <div class="rec-btn-row paused-actions">
        <button class="btn-new-step" (click)="promptNewStep()" [featureActionState]="'MOBILE_AUTOMATION'">➕ New Step</button>
        <button class="btn-stop"     (click)="stopRecording()" [featureActionState]="'MOBILE_AUTOMATION'">⏹ Stop</button>
      </div>
    </ng-container>

    <!-- ④ Stopped but steps exist -->
    <ng-container *ngIf="!isRecording && !isPaused && existingSteps.length > 0">
      <div class="gesture-label step-select-label">Continue in existing step:</div>
      <div class="existing-steps-list">
        <button
          *ngFor="let s of existingSteps"
          class="existing-step-btn"
          (click)="continueInStep(s.name)"
          [featureActionState]="'MOBILE_AUTOMATION'">
          <span class="step-btn-name">{{ s.name }}</span>
          <span class="step-btn-count">{{ s.actions.length }}</span>
        </button>
      </div>
    </ng-container>
  </div>

  <!-- ── Step name modal ─────────────────────────────────────────────────── -->
  <div class="modal-backdrop" *ngIf="showStepModal" (click)="cancelStepModal()">
    <div class="modal" (click)="$event.stopPropagation()">

      <div class="modal-header">
        <span class="modal-title">
          {{ modalMode === 'new-step' ? '➕ New step name' : 'Name this recording' }}
        </span>
      </div>

      <p class="modal-desc">
        {{ modalMode === 'new-step'
            ? 'Current step will be saved. Enter a name for the new step.'
            : 'Give this step a name before recording starts.' }}
      </p>

      <!-- Input -->
      <input
        #stepNameInput
        class="modal-input"
        [class.modal-input--error]="stepNameError !== null"
        [(ngModel)]="stepNameValue"
        placeholder="e.g. Login_Flow, Add_to_Cart…"
        (ngModelChange)="validateStepName($event)"
        (keydown.enter)="confirmStepName()"
        (keydown.escape)="cancelStepModal()"
        maxlength="60"
        [featureActionState]="'MOBILE_AUTOMATION'"/>

      <!-- Loading indicator while fetching DB step names -->
      <div class="modal-status modal-status--loading" *ngIf="isLoadingStepNames">
        <span class="modal-spinner"></span>
        Checking existing step names…
      </div>

      <!-- DB fetch error (non-blocking — user can still proceed) -->
      <div class="modal-status modal-status--warn" *ngIf="stepNamesLoadError && !isLoadingStepNames">
        ⚠️ Could not verify against saved steps. Duplicate check may be incomplete.
      </div>

      <!-- Validation error -->
      <div class="modal-error" *ngIf="stepNameError !== null && !isLoadingStepNames">
        <span class="modal-error-icon">⚠️</span>
        {{ stepNameErrorMessage }}
      </div>

      <!-- Format hint when field is empty -->
      <div class="modal-hint" *ngIf="!stepNameValue && !isLoadingStepNames">
        Must start with a letter or underscore. Only letters, digits,
        <code>_</code>, <code>-</code>, and spaces allowed.
      </div>

      <div class="modal-actions">
        <button class="btn-modal-cancel" (click)="cancelStepModal()">Cancel</button>
        <button class="btn-modal-confirm" [disabled]="!isStepNameValid" (click)="confirmStepName()" [featureActionState]="'MOBILE_AUTOMATION'">
          {{ modalMode === 'new-step' ? '➕ Create Step' : '⏺ Start Recording' }}
        </button>
      </div>

    </div>
  </div>

  <!-- ── Type input panel ────────────────────────────────────────────────── -->
  <div class="type-panel" *ngIf="showTypePanel">
    <div class="panel-divider"></div>
    <div class="type-panel-inner">
      <div class="gesture-label">⌨️ Type text</div>
      <input
        #typeInputRef
        class="type-input"
        [(ngModel)]="typeValue"
        placeholder="Enter text to send…"
        (keydown.enter)="confirmType()"
        (keydown.escape)="cancelType()"
        [featureActionState]="'MOBILE_AUTOMATION'" />
      <div class="type-actions">
        <button class="btn-type-cancel"  (click)="cancelType()">Cancel</button>
        <button class="btn-type-clear-send" [disabled]="!typeValue.trim()" (click)="confirmClearAndType()" title="Clear existing text on device and type this instead" [featureActionState]="'MOBILE_AUTOMATION'">✕ Clear & Send</button>
        <button class="btn-type-confirm" [disabled]="!typeValue.trim()" (click)="confirmType()" [featureActionState]="'MOBILE_AUTOMATION'">Send ↵</button>
      </div>
    </div>
  </div>

</div>